// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1Uwy4","range":"MonthRangeSwitch_range__E_PuP","disabled":"MonthRangeSwitch_disabled__3d2ky"};